<template>
 <el-form>
    <el-row :gutter="guts">

    <el-col :span="12">
      <text-input label="Name" v-model="row.name" :disabled="disabled" />
    </el-col>

    <el-col :span="12">
      <integer-input label="Incr. Per Year" :min="0" :max="100" v-model="row.percentIncreasePerYear" suffix="%" :disabled="disabled" />
    </el-col>

  </el-row>
</el-form>

</template>



<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [NumberMixins],

  props: {
    rowData: {
      type: Object,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    years: function () {
      this.row.years = (this.row.toMonth - this.row.fromMonth) / 12
      return this.formatNumber(this.row.years, 1)
    }
  },

  watch: {
    editMode: function (val) {
      this.disabled = val
    }
  },

  data () {
    return {
      guts: 12,
      disabled: this.editMode,
      row: this.rowData ? this.rowData : this.getTableStruct('rates')
    }

  }


}
</script>
